import { assets as assetsNs, debt as debtNs, plan as planNs, type Day, type Plan } from '@map-my-money/engine';

/**
 * The day the last mortgage is cleared: every active debt linked to a property, at its own payoff
 * date (the date the Plan screen shows) or the sale that settles it, whichever is first. null when
 * the plan has no such debt or one is never paid off at its payment. Older-format properties with
 * an embedded mortgage and no linked debt are not counted.
 */
export function mortgageFreeDate(plan: Plan, today: Day): Day | null {
  const properties = planNs.propertyIds(plan);
  const mortgages = plan.transactions.filter((t) => t.type === 'debt' && t.isActive && !planNs.countsAsDebt(t, properties));
  if (mortgages.length === 0) return null;
  const settled = assetsNs.saleSettlements(assetsNs.planSaleDates(plan), mortgages);
  let latest: Day | null = null;
  for (const m of mortgages) {
    const paidOff = debtNs.payoffDate(m, today, today);
    const sold = settled.get(m.id);
    const cleared = sold === undefined ? paidOff : paidOff === null ? sold : (Math.min(paidOff, sold) as Day);
    if (cleared === null) return null;
    if (latest === null || cleared > latest) latest = cleared;
  }
  return latest;
}
